import { IDepartmentState } from "../types";

const state = (): IDepartmentState => ({
  departments: [],
  isFetchingDepartments: false,
  departmentActionLoading: false,
});

export default state;
